import { Button, Typography } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import React from 'react';
import logo from '../../../assets/axcess logo_reversed-1.svg';
import pdf from '../../../assets/dummy.pdf';
import { Box } from '../../UI';
import GetAppIcon from '@material-ui/icons/GetApp';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import { Link } from 'react-router-dom';

export default function Summary({ propertyData, acceptedTerms }) {
	const classes = useStyles();
	return (
		<>
			<Box mb="1rem">
				<ExpansionPanel>
					<ExpansionPanelSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1a-content"
						id="panel1a-header"
					>
						<Typography variant="h6">
							<strong>
								Details
							</strong>
						</Typography>
					</ExpansionPanelSummary>
					<ExpansionPanelDetails>
						<TableContainer>
							<Table aria-label="simple table">
								<TableRow>
									<TableCell component="th" scope="row">
										<strong>City</strong>
									</TableCell>
									<TableCell align="right">{propertyData.sell.city}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell component="th" scope="row">
										<strong>Country</strong>
									</TableCell>
									<TableCell align="right">{propertyData.sell.country}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell component="th" scope="row">
										<strong>NLA</strong>
										<Tooltip title="Net Lettable Area" aria-label="info">
											<IconButton color="inherit" aria-label="menu">
												<InfoIcon style={{ fontSize: '16px' }} color="primary" />
											</IconButton>
										</Tooltip>
									</TableCell>
									<TableCell align="right">
										{propertyData.analysis.details.NLA.sqft.toLocaleString()} sq ft (c.{' '}
										{propertyData.analysis.details.NLA.sqm.toLocaleString()} sqm)
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell component="th" scope="row">
										<strong>GRI</strong>
										<Tooltip title="Gross Rental Income" aria-label="info">
											<IconButton color="inherit" aria-label="menu">
												<InfoIcon style={{ fontSize: '16px' }} color="primary" />
											</IconButton>
										</Tooltip>
									</TableCell>
									<TableCell align="right">
										£{acceptedTerms && propertyData.analysis.details.GRI.gbp.toLocaleString()}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell component="th" scope="row">
										<strong>WAULT</strong>
										<Tooltip title="Weighted Average Uninterrupted Lease Term" aria-label="info">
											<IconButton color="inherit" aria-label="menu">
												<InfoIcon style={{ fontSize: '16px' }} color="primary" />
											</IconButton>
										</Tooltip>
									</TableCell>
									<TableCell align="right">
										{acceptedTerms && propertyData.analysis.details.wault} y
									</TableCell>
								</TableRow>
							</Table>
						</TableContainer>
					</ExpansionPanelDetails>
				</ExpansionPanel>
			</Box>

			<ExpansionPanel>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1b-content"
					id="panel1b-header"
				>
					<Box display="inline-block">
						<Box className={classes.status} display="flex" flexDirection="row" alignItems="center">
							<img src={logo} alt="aXcess logo" style={{ height: '15px', marginRight: '.5rem' }} />{' '}
							<Typography variant="body1" style={{ margin: 0 }}>
								<strong>Status: {propertyData.sell.status}</strong>
							</Typography>
						</Box>
					</Box>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails>
					<Box width="100%">
						<Table className={classes.table} aria-label="simple table" size="small">
							<TableBody>
								<TableRow>
									<TableCell component="th" scope="row">
										<strong>OIEO</strong>
									</TableCell>
									<TableCell align="right">£{propertyData.analysis.details.oeio}m</TableCell>
								</TableRow>
								<TableRow>
									<TableCell component="th" scope="row">
										<strong>LOIs due</strong>
									</TableCell>
									<TableCell align="right">{propertyData.sell.loiDue}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell component="th" scope="row">
										<strong>LOIs Submission Charge</strong>
										<Tooltip
											title="This is the charge associated with submission of an LOI to the Seller – the charge is an auction participation threshold set by the seller. Payment of the charge ensures that the provider of the LOI will be informed of the auction’s outcome and asset’s clearance price. The charge will be reimbursed in full if the seller unilaterally withdraw from the auction at any time prior to the auction’s deadline or chose not to assign exclusivity to a bidder at the end of the auction process"
											aria-label="info"
										>
											<IconButton color="inherit" aria-label="menu">
												<InfoIcon style={{ fontSize: '16px' }} color="primary" />
											</IconButton>
										</Tooltip>
									</TableCell>
									<TableCell align="right">
										{acceptedTerms ? propertyData.sell.loiDeposit : 'Valid'}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell component="th" scope="row">
										<strong>Auction Date</strong>
									</TableCell>
									<TableCell align="right">{propertyData.sell.auctionDate}</TableCell>
								</TableRow>
							</TableBody>
						</Table>

						<Box display="flex" mt="2rem">
							<a
								href={pdf}
								target="_blank"
								rel="noopener noreferrer"
								style={{ textDecoration: 'none', marginLeft: '1rem' }}
							>
								<Button variant="contained" color="primary" startIcon={<GetAppIcon />}>
									Download Teaser
								</Button>
							</a>
							{!acceptedTerms ? (
								<Button variant="contained" disabled style={{ marginLeft: '1rem' }} startIcon={<GetAppIcon />}>
									Download IM
								</Button>
							) : (
								<a
									href={pdf}
									target="_blank"
									rel="noopener noreferrer"
									style={{ textDecoration: 'none', marginLeft: '1rem' }}
								>
									<Button variant="contained" color="primary" startIcon={<GetAppIcon />}>
										Download IM
									</Button>
								</a>
							)}
						</Box>
						<Box>
							<Button
								variant="contained"
								startIcon={<PlayCircleFilledIcon />}
								style={{ marginLeft: '1rem', marginTop: '1rem' }}
								disabled={!acceptedTerms}
								color="default"
							>
								Video link
							</Button>
							<Button
								variant="contained"
								style={{ marginLeft: '1rem', marginTop: '1rem' }}
								disabled={!acceptedTerms}
								color="default"
								startIcon={<ZoomOutMapIcon />}
							>
								Floor Plans
							</Button>
							<Button
								variant="contained"
								style={{ marginLeft: '1rem', marginTop: '1rem' }}
								disabled={!acceptedTerms}
								color="default"
								startIcon={<GroupAddIcon />}
								component={Link}
								to={`/market-search/${propertyData.id}/rent-roll`}
							>
								Rent Roll
							</Button>
						</Box>
					</Box>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		</>
	);
}

const useStyles = makeStyles(theme => ({
	paper: {
		width: '100%',
		height: '100%',
		padding: '15px',
		position: 'relative',
		'& p': {
			marginTop: '.5rem',
		},
	},
	status: {
		background: theme.palette.primary.main,
		padding: '10px 15px',
		borderRadius: '100px',
		color: 'white',
		display: 'inline-block',
		fontWeight: 'bold',
	},
	table: {
		width: '100%',
		marginTop: '1rem',
	},
}));
